import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { AsyncServiceBase } from './async-service-base';
import { GlobalTablesService } from './global-tables-service';
// /// <reference types="@types/googlemaps" />
// import { MapsAPILoader } from '@agm/core';
import { NomWebServicesJson } from './nom-web-services-json';
import { VisualStateService } from './visual-state-service';

@Injectable({ providedIn: 'root' })
export class MapService extends AsyncServiceBase {
    constructor(
        public globalTablesService: GlobalTablesService,
        // private mapsAPILoader: MapsAPILoader,
        public nomWebServicesJson: NomWebServicesJson,
        public visualStateService: VisualStateService,
        private httpClient: HttpClient
    ) {
        super();
        this.globalTablesService.globalTablesLoaded.subscribe(() => {
            this.loadGoogleMapsAndResolve();
        });
    }

    public async loadGoogleMapsAndResolve(): Promise<any> {
        if (!(typeof google === 'object' && typeof google.maps === 'object')) {
            await firstValueFrom(this.httpClient.jsonp(`https://maps.googleapis.com/maps/api/js?key=${this.visualStateService.ConfigSettings.LocationSettings}&libraries=places`, 'callback'));
        }

        if (this.visualStateService.ConfigSettings.LocationSettings) {
            this.autocomplete.service = new google.maps.places.AutocompleteService();
            this.autocomplete.places = new google.maps.places.PlacesService(<HTMLDivElement>document.getElementById('map'));
            this.googlemapsLoaded = true;
        }
        this.initializeResolve(null);
        // (<any>this.mapsAPILoader)._config.apiKey = this.visualStateService.ConfigSettings["LocationSettings"];
        // (<any>this.mapsAPILoader)._config.libraries = ["places"];
    }

    private googlemapsLoaded = false;
    public autocomplete: { service: google.maps.places.AutocompleteService; places: google.maps.places.PlacesService } = {
        service: null,
        places: null,
    };

    public getAutocomplete(): Promise<{ service: google.maps.places.AutocompleteService; places: google.maps.places.PlacesService }> {
        const ret = new Promise<{ service: google.maps.places.AutocompleteService; places: google.maps.places.PlacesService }>(resolve => {
            if (this.googlemapsLoaded) {
                resolve(this.autocomplete);
            } else if (this.visualStateService.ConfigSettings.LocationSettings) {
                resolve(this.autocomplete);
            } else {
                resolve(this.autocomplete);
            }
        });

        return ret;
    }
}
